import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ErrorToast } from '../../../components';
import {
  getUserFromLS,
  setUserToLS
} from '../../../helpers/localstorage-helper';
import { KYC_DOCUMENT_PHOTOS } from '../../../routes/routes';
import { changeUserInfo } from '../../../slices/auth-slice';
import { UserInfoType } from '../../../types/loginTypes';

interface AddKycDocumentType {
  type: number;
  documentHolder: string;
  history: any;
}

export const addKycDocument = createAsyncThunk(
  'kyc/addKycDocument',
  async (
    { type, documentHolder, history }: AddKycDocumentType,
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await axios.post(`/user/document`, {
        type,
        documentHolder
      });

      const kycStatus = data.data.kycStatus;

      const currentUser: UserInfoType = getUserFromLS();

      const user = { ...currentUser, kycStatus };

      dispatch(changeUserInfo(user));

      setUserToLS(user);

      history.push(`${KYC_DOCUMENT_PHOTOS}/${type}`);

      return user;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
